import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import Headline from '../../../components/headline/Headline';
import { Box, Button, Dropdown, IconButton, Menu, MenuButton, MenuItem, Table } from '@mui/joy';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import MoreVert from '@mui/icons-material/MoreVert';
function Regionalgruppen() {
    const [wit, setWit] = useState("87.5%");
    const [data, setdata] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response));
    }, []);
    function create() {
        let body = {};
        body.token = Token.get();
        body.action = "create";
        let a = prompt("Name der Regionalgruppe");
        if (!a) {
            return;
        }
        body.name = a;
        let response = post(body, "/regionalgruppen");
        console.log(response);
        if (response == "LOGOUT") {
            navigate("/");
        }
        window.location.reload();
        
    }
    function editname(id) {
        let body = {};
        body.token = Token.get();
        body.action = "edit";
        body.targetid = id;
        let a = prompt("Name der Regionalgruppe");
        if (!a) {
            return;
        }
        body.name = a;
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        window.location.reload();

    }
    function del(id) {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.targetid = id;
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        window.location.reload();
    }
    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
                <Headline title={"Regionalgruppen"} />
                <Button sx={{ mt: 2, mb: 2 }} onClick={() => create()}>Regionalgruppe erstellen</Button>
                <Button onClick={() => navigate("/page-history/regionalgruppen")}>Historie</Button>
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Bearbeiten</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.result.length > 0 && data.result.map((item) => {
                                return (<tr>
                                    <td>{item.name}</td>
                                    <td>
                                        <Dropdown>
                                            <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                                                <MoreVert />
                                            </MenuButton>
                                            <Menu>
                                                <MenuItem onClick={() => editname(item.id)}>Name Bearbeiten</MenuItem>
                                                <MenuItem onClick={() => del(item.id)} sx={{ color: "red" }}>Löschen</MenuItem>
                                            </Menu>
                                        </Dropdown>
                                    </td>
                                </tr>)
                            })
                        }
                    </tbody>
                </Table>
            </Box>

            <NavigationBar state={"adminhome"} back={true} />
        </>
    )
}

export default Regionalgruppen
